//import ApexCharts from 'apexcharts'
//import $ from 'jquery'

export default {
    methods: {
        loadScript(url) {
            const body = document.body;
            const script = document.createElement("script");
            script.innerHTML = "";
            script.src = url;
            script.async = false;
            script.defer = true;
            body.appendChild(script);
        },
        footerScriptChangeBatchSize(event) {
            localStorage.setItem('page_size', event.target.value); // navigate with new size
            //this.$router.push({name: this.$options.name});

            let queryObject = {}; //source: "story_tray"
            let updateQuery = this.$router.currentRoute.value.query;
            Object.keys(updateQuery).forEach(key => {
                queryObject[key] = updateQuery[key];
            })
            queryObject.size = event.target.value;
            this.$router.push({ path: this.$router.currentRoute.value.path, query: queryObject });
        },
        loadScriptData(newData) {
            const body = document.body;
            const script = document.createElement("script");
            script.innerHTML = newData;
            body.appendChild(script);
        },
        offCanvasScript(){
            this.loadScript(`${this.cdn}/assets/js/off-canvas.js`);
        },
        asideBarScript() {
            this.loadScript(`${this.cdn}/assets/js/dashforge.aside.js`);
        },
        footerScript() {
            this.loadScript(`${this.cdn}/lib/jquery/jquery.min.js`)
            this.loadScript(`${this.cdn}/lib/bootstrap/js/bootstrap.bundle.min.js`)
            this.loadScript(`${this.cdn}/lib/feather-icons/feather.min.js`)
            this.loadScript(`${this.cdn}/lib/ionicons/ionicons/ionicons.esm.js" type="module`)
            this.loadScript(`${this.cdn}/lib/perfect-scrollbar/perfect-scrollbar.min.js`)
            this.loadScript(`${this.cdn}/assets/js/dashforge.js`)
            this.loadScript(`${this.cdn}/lib/js-cookie/js.cookie.js`);
            this.loadScript(`${this.cdn}/lib/select2/js/select2.min.js`)
            this.loadScript(`${this.cdn}/lib/perfect-scrollbar/perfect-scrollbar.min.js`)
            this.loadScript(`${this.cdn}/lib/prismjs/prism.js`)
            this.loadScript(`${this.cdn}/lib/jqueryui/jquery-ui.min.js`)
            this.loadScript(`${this.cdn}/assets/js/script.js`);
        },

        contactScript() {
            this.loadScript(`${this.cdn}/assets/js/dashforge.contacts.js`);
        },
        mixinFileTableScript() {
            this.loadScript(`${this.cdn}/assets/js/dashforge.filemgr.js`);
        },
        calendarScript() {
            this.loadScript(`${this.cdn}/assets/js/dashforge.filemgr.js`);
        },
        mailFooterScript() {
            this.loadScript(`${this.cdn}/lib/jquery/jquery.min.js`)
            this.loadScript(`${this.cdn}/lib/bootstrap/js/bootstrap.bundle.min.js`)
            this.loadScript(`${this.cdn}/lib/feather-icons/feather.min.js`)
            this.loadScript(`${this.cdn}/lib/perfect-scrollbar/perfect-scrollbar.min.js`)
            this.loadScript(`${this.cdn}/lib/quill/quill.min.js`)

            this.loadScript(`${this.cdn}/assets/js/dashforge.js`);
            this.loadScript(`${this.cdn}/assets/js/dashforge.mail.js`);
        },
    },
    mount() {

    },
};




// <script src="../../lib/jquery/jquery.min.js"></script>
// <script src="../../lib/bootstrap/js/bootstrap.bundle.min.js"></script>
// <script src="../../lib/feather-icons/feather.min.js"></script>
// <script src="../../lib/ionicons/ionicons/ionicons.esm.js" type="module"></script>
// <script src="../../lib/perfect-scrollbar/perfect-scrollbar.min.js"></script>
// <script src="../../lib/chart.js/Chart.bundle.min.js"></script>
//
//
// <script src="../../assets/js/dashforge.js"></script>
// <script src="../../assets/js/dashforge.aside.js"></script>
//
//
// <!-- append theme customizer -->
// <script src="../../lib/js-cookie/js.cookie.js"></script>

